import { AbsoluteCenter, Box, Flex, Text } from '@chakra-ui/react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import i18next from 'i18next';
import { slice } from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { gradientStyle } from '@/utils/styles.utils';

import { getRankingList } from '../../../api/getApi';
import { COMMON_WEB_PATH, COMMON_WEB_PATH_JP } from '../../../constant';
import useCheckLogin from '../../../hook/useCheckLogin';
import useDeviceType from '../../../hook/useDeviceType';
import { notice } from '../../../redux/action/action';
import { REPLACE_AIR } from '../../../replace_str_constant';
import { special2TextGradientStyle } from '../../../utils/specialTextGradientStyle';
import RankingNumberCount from './RankingNumberCount';
import useGames from '@/pages/Game/useGames';

const rank_config = {
  1: {
    color: '#158399'
  },
  2: {
    color: '#AE2F80'
  },
  3: {
    color: '#E66700'
  },
  4: {
    color: '#5D4ABC'
  }
};

const TopGameBoard = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const splideRef = useRef();

  const [rankingList, setRankingList] = useState([]);

  const isMobile = useDeviceType() === 'Mobile';
  const dispatch = useDispatch();
  const { isLogin } = useCheckLogin();
  const navigate = useNavigate();

  const { handlePlayGame } = useGames();

  const handleEnterGame = useCallback(
    (gameItem) => {
      const { platform, game_name_en, game_uid } = gameItem || {};
      handlePlayGame({
        gameName: game_name_en,
        gamePlatform: platform,
        gameUid: game_uid
      });
    },
    [isLogin]
  );

  useEffect(() => {
    getRankingList().then((data) => {
      const result = data?.data;

      const topThree = slice(result, 0, 10);
      setRankingList(topThree);
    });
  }, []);
  return (
    <>
      <Box paddingBottom={{ base: '0.5em', sm: 'none' }}>
        <Flex maxW="100vw" overflowX="auto" gap="15px">
          {rankingList?.map((item, index) => {
            const { platform, game_code, profit } = item;
            return (
              <Box
                minW={{
                  base: '35vw',
                  lg: '230px'
                }}
                maxW={{
                  base: '200px',
                  lg: '230px'
                }}
                h={{ base: '75px', sm: '95px' }}
                ml={{ base: '0.9em', sm: '30px' }}
                bgImage={`url(${COMMON_WEB_PATH}/blue-layout/ranking/ranking-bg-1.png)`}
                bgSize="107% 113%"
                bgPos="center"
                bgRepeat="no-repeat"
                display={'flex'}
                alignItems={'flex-start'}
                gap="10px"
                cursor={'pointer'}
                onClick={() => handleEnterGame(item)}
                justifyContent={'space-between'}
                position="relative"
                pr={'1em'}
                pl={'0.5em'}
                pt={'0.5em'}
                pb={'0.5em'}
              >
                <Box
                  alignItems={'center'}
                  display="flex"
                  gap="5px"
                  overflow={'hidden'}
                  h="100%"
                  w="100%"
                >
                  <Box
                    minW={'3em'}
                    minH={'3em'}
                    maxW={'3em'}
                    maxH={'3em'}
                    borderRadius={'100%'}
                    overflow="hidden"
                  >
                    <LazyLoadImage
                      src={`${COMMON_WEB_PATH_JP}/game-icon-ds88/en/${platform}/${REPLACE_AIR(
                        game_code
                      )}.webp`}
                    />
                  </Box>
                  <Box w="100%" display="flex" flexDirection={'column'}>
                    <Flex
                      h={{
                        base: '30px',
                        md: '37px'
                      }}
                      alignItems={'center'}
                    >
                      <Text
                        className="text-overflow"
                        fontSize={{ base: '0.8em', sm: '1.3em' }}
                        fontWeight={700}
                        color="white"
                      >
                        {item?.[`game_name_en`] || '-'}
                      </Text>
                    </Flex>
                    <Flex
                      fontSize={{
                        base: '17px',
                        md: '1.2em'
                      }}
                      color="#fff"
                      alignItems={'center'}
                      gap="2.5px"
                      flex={1}
                    >
                      <Text
                        letterSpacing="-2px"
                        fontWeight={900}
                        sx={gradientStyle}
                      >
                        <RankingNumberCount value={profit} />
                      </Text>
                    </Flex>
                  </Box>
                </Box>
                <AbsoluteCenter
                  position="absolute"
                  left={{ base: '0', sm: '-0.5em' }}
                  bgImage={`url(${COMMON_WEB_PATH}/blue-layout/ranking/ranking-${
                    index + 1
                  }.png)`}
                  bgSize="100% 100%"
                  w={{ base: '2em', sm: '3em' }}
                  h={{ base: '2em', sm: '3em' }}
                  bgPos="center"
                  zIndex={10}
                ></AbsoluteCenter>
              </Box>
            );
          })}
        </Flex>
      </Box>
    </>
  );
};

export default TopGameBoard;
